import PropTypes from 'prop-types';
import PageShell from '../../../components/layout/PageShell';

// ✅ Custom breadcrumbs example:
// const crumbs = [
//   { label: 'Home', to: '/' },
//   { label: 'Community', to: `/community/${communityId}` },
//   { label: 'Match Manager', to: `/community/${communityId}/match-manager/${managerId}` },
//   { label: 'Manual Match Format' },
// ];
// <PageShell breadcrumbs={crumbs}>...</PageShell>
// <PageShell breadcrumbOverrides={{ tournamentId: tournament?.name || 'Tournament' }}>
function StaticInfoPage({ title, description, badgeText }) {
  return (
    <PageShell containerClassName="p-0">
    <div className="py-4 d-flex flex-column gap-3 align-items-start">
      {badgeText ? (
        <span className="badge bg-primary-subtle text-primary-emphasis">{badgeText}</span>
      ) : null}
      <h1 className="h3 mb-1">{title}</h1>
      <p className="text-muted mb-0">{description}</p>
    </div>
  
    </PageShell>
  );
}

StaticInfoPage.propTypes = {
  badgeText: PropTypes.string,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

StaticInfoPage.defaultProps = {
  badgeText: undefined,
};

export default StaticInfoPage;
